<span class="throbber" :class="classModifiers">
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
    <span class="throbber_item"><span class="throbber_line"></span></span>
</span>
